(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dabi-configurator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (section) => {
      if (!section || section.dataset.dabiConfigReady === 'true') return;
      const form = section.querySelector('[data-dabi-config-form]');
      if (!form) return;
      section.dataset.dabiConfigReady = 'true';

      const canvas = section.querySelector('[data-dabi-canvas]');
      const layers = section.querySelector('[data-dabi-layers]');
      const chips = section.querySelector('[data-dabi-chips]');
      const totalOut = section.querySelector('[data-dabi-total]');
      const totalInput = section.querySelector('[data-dabi-total-input]');
      const message = section.querySelector('[data-dabi-message]');
      const missing = section.querySelector('[data-dabi-missing]');
      const base = Number(section.dataset.dabiBase || 0);

      const groups = Array.from(section.querySelectorAll('[data-dabi-group]'));
      const notes = Array.from(section.querySelectorAll('[data-dabi-note]'));

      const money = (cents) => {
        const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'tr', {
            style: 'currency',
            currency,
          }).format(cents / 100);
        } catch {
          return `${(cents / 100).toFixed(2)} ${currency}`;
        }
      };

      const selectionOf = (group) => group.querySelector('[data-dabi-choice].is-selected');

      const refresh = () => {
        let total = base;
        const lines = [];

        groups.forEach((group) => {
          const chosen = selectionOf(group);
          const input = group.querySelector('[data-dabi-group-input]');
          if (!chosen) {
            if (input) input.value = '';
            return;
          }
          const price = Number(chosen.dataset.choicePrice || 0);
          total += price;
          const label = group.dataset.groupLabel;
          const value = chosen.dataset.choiceLabel;
          if (input) input.value = price > 0 ? `${value} (+${money(price)})` : value;
          lines.push({ label, value });
        });

        notes.forEach((note) => {
          if (note.value.trim() !== '') total += Number(note.dataset.notePrice || 0);
        });

        totalOut.textContent = money(total);
        if (totalInput) totalInput.value = money(total);

        chips.innerHTML = '';
        lines.forEach((line) => {
          const item = document.createElement('li');
          item.innerHTML = `${line.label}: <b></b>`;
          item.querySelector('b').textContent = line.value;
          chips.appendChild(item);
        });

        // Katmanlı önizleme: seçeneğin üst görseli varsa tuvale bindirilir.
        layers.innerHTML = '';
        groups.forEach((group) => {
          const chosen = selectionOf(group);
          const overlay = chosen && chosen.dataset.choiceOverlay;
          if (!overlay) return;
          const image = document.createElement('img');
          image.src = overlay;
          image.alt = '';
          layers.appendChild(image);
        });
      };

      const pick = (choice) => {
        const group = choice.closest('[data-dabi-group]');
        if (!group) return;
        group.querySelectorAll('[data-dabi-choice]').forEach((other) =>
          other.classList.toggle('is-selected', other === choice)
        );
        refresh();
      };

      section.querySelectorAll('[data-dabi-choice]').forEach((choice) => {
        choice.addEventListener('click', () => pick(choice));
        choice.addEventListener('dragstart', (event) => {
          choice.classList.add('is-dragging');
          event.dataTransfer.effectAllowed = 'copy';
          event.dataTransfer.setData('text/plain', choice.dataset.choiceLabel || '');
          window.__dabiDragged = choice;
        });
        choice.addEventListener('dragend', () => {
          choice.classList.remove('is-dragging');
          window.__dabiDragged = null;
        });
      });

      notes.forEach((note) => note.addEventListener('input', refresh));

      if (canvas) {
        canvas.addEventListener('dragover', (event) => {
          event.preventDefault();
          event.dataTransfer.dropEffect = 'copy';
          canvas.classList.add('is-dropping');
        });
        canvas.addEventListener('dragleave', () => canvas.classList.remove('is-dropping'));
        canvas.addEventListener('drop', (event) => {
          event.preventDefault();
          canvas.classList.remove('is-dropping');
          if (window.__dabiDragged) pick(window.__dabiDragged);
        });
      }

      // Zorunlu gruplar secilmeden gonderilmesin.
      form.addEventListener('submit', (event) => {
        const eksik = groups
          .filter((group) => group.dataset.groupRequired === 'true' && !selectionOf(group))
          .map((group) => group.dataset.groupLabel);

        if (eksik.length > 0) {
          event.preventDefault();
          missing.hidden = false;
          missing.textContent = `${missing.dataset.prefix || ''} ${eksik.join(', ')}`.trim();
          missing.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        missing.hidden = true;

        // Secimler mesaj govdesine de yaziliyor: e-postada tek bakista okunsun.
        const ozet = groups
          .map((group) => {
            const chosen = selectionOf(group);
            return chosen ? `${group.dataset.groupLabel}: ${chosen.dataset.choiceLabel}` : null;
          })
          .filter(Boolean)
          .join('\\n');
        const mevcut = message.value.trim();
        message.value = `${ozet}\\n${totalOut.textContent}${mevcut ? `\\n\\n${mevcut}` : ''}`;
      });

      refresh();
    };

    document.querySelectorAll('[data-dabi-config]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) =>
      initialise(event.target.querySelector('[data-dabi-config]'))
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (section) => {
      if (!section || section.dataset.dabiShowcaseReady === 'true') return;
      const viewer = section.querySelector('[data-dabi-showcase-viewer]');
      if (!viewer) return;
      section.dataset.dabiShowcaseReady = 'true';

      const panel = viewer.querySelector('.dabi-showcase__viewer-panel');
      const stage = viewer.querySelector('[data-dabi-showcase-stage]');
      const image = viewer.querySelector('[data-dabi-showcase-image]');
      const caption = viewer.querySelector('[data-dabi-showcase-caption]');
      const cursor = viewer.querySelector('[data-dabi-showcase-cursor]');
      const shots = Array.from(section.querySelectorAll('[data-dabi-shot]'));
      let index = 0;
      let opener = null;

      const show = (next) => {
        if (shots.length === 0) return;
        index = (next + shots.length) % shots.length;
        image.src = shots[index].dataset.shotFull;
        image.alt = shots[index].dataset.shotAlt || '';
        caption.textContent = shots[index].dataset.shotAlt || '';
      };

      const close = () => {
        viewer.hidden = true;
        document.documentElement.style.overflow = '';
        opener?.focus();
        opener = null;
      };

      shots.forEach((shot, i) => {
        shot.addEventListener('click', () => {
          opener = shot;
          show(i);
          viewer.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          panel.focus();
        });
      });

      const place = (event) => {
        if (shots.length < 2) return;
        const box = stage.getBoundingClientRect();
        const x = event.clientX - box.left;
        cursor.style.left = `${x}px`;
        cursor.style.top = `${event.clientY - box.top}px`;
        cursor.dataset.direction = x < box.width / 2 ? 'prev' : 'next';
        cursor.classList.add('is-visible');
      };

      stage.addEventListener('pointerenter', place);
      stage.addEventListener('pointermove', place);
      stage.addEventListener('pointerleave', () => cursor.classList.remove('is-visible'));
      stage.addEventListener('click', (event) => {
        if (shots.length < 2) return;
        const box = stage.getBoundingClientRect();
        show(index + (event.clientX - box.left >= box.width / 2 ? 1 : -1));
      });

      viewer.querySelectorAll('[data-dabi-showcase-close]').forEach((button) =>
        button.addEventListener('click', close)
      );
      document.addEventListener('keydown', (event) => {
        if (viewer.hidden) return;
        if (event.key === 'Escape') close();
        if (event.key === 'ArrowRight') show(index + 1);
        if (event.key === 'ArrowLeft') show(index - 1);
      });
    };

    document.querySelectorAll('[data-dabi-showcase]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) =>
      initialise(event.target.querySelector('[data-dabi-showcase]'))
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
